import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask1100To1199Service {

  constructor() { }
}
